import React from 'react'

const RateLimitWarning = () => {
  return (
    <div>
      <i
        className='fa fa-exclamation-triangle md-24 sm-24 xs-24'
        style={{
          fontSize: 18,
          color: 'orange',
          verticalAlign: 'middle'
        }}
      />{' '}
      &nbsp;
      <span
        style={{
          fontSize: 12,
          fontStyle: 'italic',
          verticalAlign: 'middle',
          fontWeight: 'bold',
          textDecorationLine: 'underline'
        }}
      >
        Very Important!
      </span>
      <span
        style={{
          fontSize: 12,
          fontStyle: 'italic',
          verticalAlign: 'middle'
        }}
      >
        &nbsp; This requires that you have been granted permission from Twitter
        to increase the limit. &nbsp;
      </span>
      <span
        style={{
          fontSize: 12,
          fontStyle: 'italic',
          verticalAlign: 'middle',
          fontWeight: 'bold',
          textDecorationLine: 'underline'
        }}
      >
        Do not proceed otherwise.
      </span>
      <p />
    </div>
  )
}

export default RateLimitWarning



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-rate-limits/components/rate-limit-warning.js